import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/** Explains the deleted view above a list while "Show deleted" is on. */
export function DeletedViewBanner({ className }: { className?: string }) {
	const { t } = useTranslation();
	return (
		<div
			className={cn(
				'flex items-center gap-2 rounded-md border border-zinc-300 bg-zinc-50 px-3 py-2 text-sm text-zinc-700 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300',
				className,
			)}
		>
			<Info className="size-4 shrink-0" />
			{t('common.deleted.banner')}
		</div>
	);
}
